import React, { memo, useCallback, useMemo } from "react";
import DommusToggle from "../../../../components/DommusToggle";
import DommusTabelaPaginada from "../../../../components/DommusTabelaPaginada";
import { LinhaContato } from "./LinhaContato";
import "./index.scss";
import MidiaSocialIcone from "../../../../components/MidiaSocialIcone";

export const MeioComunicacaoSection = memo(({meioComunicacao, listaAgentesAtivos}) => {

  const thead = (
    <tr>
      <th style={{width: '25%'}}>
        Nome:
      </th>
      <th style={{width: '20%'}}>
        Contato:
      </th>
      {meioComunicacao?.slug === 'whatsapp' && (
        <th style={{width: '20%'}}>
          Agente de IA:
        </th>
      )}
      <th className='text-center' style={{width: '1%'}}>
        Ações:
      </th>
    </tr>
  );

  const trows = useMemo(() => {
    return meioComunicacao?.contatos_origem?.map((contato, index) => {
      return (
        <LinhaContato
          key={index}
          contato={contato}
          idMeio={meioComunicacao?.id}
          slugMeio={meioComunicacao?.slug}
          listaAgentesAtivos={listaAgentesAtivos}
        />
      );
    }) ?? []
  }, [meioComunicacao, listaAgentesAtivos]);

  const titleMeio = useMemo(() => {
    return (
      <div className="title-meio-section">
        <MidiaSocialIcone midia={meioComunicacao?.slug} />
        <span>{meioComunicacao?.nome}</span>
      </div>
    )
  },[meioComunicacao])

  return (
    <DommusToggle title={titleMeio} toggle={true} bodyClass="contatos-origem-section-body">
      <DommusTabelaPaginada linhasCabecalho={thead} optionsTabela={{}} linhasCorpo={trows}/>
    </DommusToggle>
  )
})
